import React, { useState, useEffect } from 'react';
import { InputGroup, Form, Button } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons'; // Assuming you are using react-bootstrap-icons

function SearchBar({ initialSearchType = "Community", initialSearchValue, onSearch }) {
    const [searchType, setSearchType] = useState(initialSearchType); // Use initialSearchType as default
    const [searchValue, setSearchValue] = useState(initialSearchValue);

    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleDropdownChange = (e) => {
        setSearchType(e.target.value);
    };

    const handleSearchClick = () => {
        onSearch(searchType, searchValue);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    const handleDoubleClick = (e) => {
        e.target.select(); // Select all text on double-click
    };

    useEffect(() => {
        setSearchType(initialSearchType); // Update search type when initialSearchType changes
    }, [initialSearchType]);

    // Define which types should only accept numeric input
    const isNumericInput = ["Post", "Review", "Proposal", "Bounties"].includes(searchType);

    return (
        <InputGroup className="outline-info" style={{ width: '100%' }}>
            <Form.Control
                as="select"
                value={searchType}
                onChange={handleDropdownChange}
                style={{ maxWidth: '200px' }}
            >
                <option value="Community">Community</option>
                <option value="Post">Post</option>
                <option value="Member">Member</option>
                <option value="Review">Review</option>
                <option value="Proposal">Proposal</option>
                <option value="Bounties">Bounties</option>
                <option value="ParameterGroups">Parameter Groups</option>
            </Form.Control>
            <Form.Control
                type={isNumericInput ? "number" : "text"}
                inputMode={isNumericInput ? "numeric" : "text"} // This will suggest the correct keyboard for mobile users
                placeholder="Enter Value"
                value={searchValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onDoubleClick={handleDoubleClick} // Select all text when double-clicked
            />
            <Button variant="info" onClick={handleSearchClick}>
                <Search />
            </Button>
        </InputGroup>
    );
}

export default SearchBar;
